var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tree-item-wrapper mx-4', { 'last-item': _vm.last }]},[_c('li',{staticClass:"tree-item pt-3"},[_c('div',{staticClass:"tree-item-content pd-12",class:_vm.variant},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }